/**
 * CHECKOUT ROUTES
 */
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';

const languageRegex = process.env.VUE_APP_LANGUAGE_CODES.split(',').join('|');

export default [
  {
    path: `/:lang(${languageRegex})?/checkout`,
    alias: `/:lang(${languageRegex})?/checkout-summary`,
    name: 'checkout',
    component: () => import('@/views/checkout/IndexPage.vue'),
    meta: { layout: 'default' },
  },
  {
    path: `/:lang(${languageRegex})?/payment/success`,
    name: 'checkout-payment-success',
    component: () => {
      if (featureFlagMixin.methods.isFeatureEnabled('payment_success_2024')) {
        return import('@/views/payment/PaymentSuccess.vue');
      }
      return import('@/views/checkout/sections/PaymentSuccessPage.vue');
    },
    meta: { layout: 'default' },
  },
];
